module.exports = __webpack_public_path__ + "media/images/expert__diego-benaglio-6544a7bdf265f3d517080d239a833f9e.png";